import Icon from '@/components/ui/AppIcon';

interface Step {
  id: string
  number: number
  title: string
  description: string
  icon: string
}

const steps: Step[] = [
  {
    id: 'step_1',
    number: 1,
    title: 'Search & Discover',
    description: 'Browse over 1,000 saints by name, patronage, or feast day. Use our powerful search to find the perfect saint for your needs.',
    icon: 'MagnifyingGlassIcon',
  },
  {
    id: 'step_2',
    number: 2,
    title: 'Learn Their Story',
    description: 'Read detailed biographies, learn about their patronages, and discover their feast days and historical significance.',
    icon: 'BookOpenIcon',
  },
  {
    id: 'step_3',
    number: 3,
    title: 'Pray with Them',
    description: 'Access traditional prayers, novenas, and litanies. Download prayer cards to keep with you or share with others.',
    icon: 'HandRaisedIcon',
  },
  {
    id: 'step_4',
    number: 4,
    title: 'Shop & Honor',
    description: 'Purchase meaningful merchandise like medals, statues, prayer cards, and more to honor your chosen saint.',
    icon: 'ShoppingBagIcon',
  },
]

export default function HowItWorksSection() {
  return (
    <section className="py-24 px-6 bg-primary/5 reveal">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
            How It Works
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4">
            Your Journey with SaintSeek
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From discovery to devotion in four simple steps
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Connection Line - Desktop Only */}
          <div className="hidden lg:block absolute top-20 left-0 right-0 h-0.5 bg-border">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/50 to-transparent" />
          </div>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {steps.map((step, index) => (
              <div
                key={step.id}
                className="relative"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                {/* Step Card */}
                <div className="glass-card p-8 rounded-2xl hover:shadow-xl transition-all duration-300 h-full border-2 border-transparent hover:border-primary/20">
                  {/* Number Badge */}
                  <div className="relative mb-6">
                    <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shadow-lg">
                      <Icon name={step.icon as any} size={32} className="text-white" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-accent rounded-full flex items-center justify-center border-4 border-white">
                      <span className="text-sm font-bold text-foreground">
                        {step.number}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-serif font-bold text-foreground mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Arrow - Desktop Only */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 -right-3 text-primary/30">
                    <Icon name="ArrowRightIcon" size={24} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}